export const RUNNING_AB_OPTIMIZER_TIP = '运行中实验不建议改配置；请结束实验或复制为新版本';

/** 所有诊断策略的统一执行门禁；UI 禁用不能替代执行入口校验。 */
export function guardFormOptimizerApply(
  readOnly: boolean,
  notify: (message: string) => void
): boolean {
  if (!readOnly) return true;
  notify(RUNNING_AB_OPTIMIZER_TIP);
  return false;
}
